import { ActivatedRoute } from '@angular/router';
import { OrderStateModel } from '../../../../models/order.state.model';

export class CreatePaymentRedirectUrlDto {
  public paymentChannel: string;
  public state: OrderStateModel;
  public route: ActivatedRoute;
}
